import { render, staticRenderFns } from "./Ability.vue?vue&type=template&id=48fda234&"
import script from "./Ability.vue?vue&type=script&lang=js&"
export * from "./Ability.vue?vue&type=script&lang=js&"
import style0 from "./Ability.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports